// extracted by mini-css-extract-plugin
module.exports = {"editor":"description_editor__nxgi_"};